<template>
    <div>
        <header>
            <el-form :inline="true" class="demo-form-inline" label-width="100px" size="small">
                <el-form-item label="费用查询" >
                    <el-input clearable v-model="condition" placeholder="请输入费用名称"
                        style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary" @click="search">查询</el-button>
                    <el-button v-if="rolePermission === '领导' || rolePermission === '主管'" type="success" @click="update">增加</el-button>
                </el-form-item>
            </el-form>
        </header>
        <main>
                <el-table :data="list" height="calc(100vh - 136px)" :cell-style="rowStyle" id="tableId" ref="tableId"
                   style="font-size: 14px; margin-top: 0px;" size="mini">
                    <el-table-column label="序号" type="index" width="60" align="center">
                    </el-table-column>
                    <el-table-column label="费用名称" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.feeName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="税率" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-mingcheng"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.tax }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="auto" align="center">
                        <template slot-scope="scope">
                            <el-switch @change="changeStatus(scope.row)" v-model="scope.row.status"
                                active-color="#13ce66" inactive-color="#ff4949">
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="auto" align="center" v-if="rolePermission === '领导' || rolePermission === '主管'">
                        <template slot-scope="scope">
                            <el-button round size="small" icon="el-icon-edit" type="warning"
                                @click="amendRow(scope.row)">修改</el-button>
                            <el-button plain size="small" icon="el-icon-delete" type="danger"
                                @click="deleteRow(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            <!-- <div>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 50, 100]" :page-size="10" style="padding: 10px;"
                    layout="sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div> -->

            <!-- 修改费用信息弹出框 -->
            <el-dialog title="费用信息" :close-on-click-modal="false" :show-close="false" :visible.sync="dialogFormVisible">
                <el-form :rules="rules">
                    <el-form-item required label="费用名称">
                        <el-input v-model="feeName" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item required label="税率">
                        <el-input v-model.trim="tax" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button  @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="confirmChange">确 定</el-button>
                </div>
            </el-dialog>
        </main>
    </div>
</template>

<script>
import req from '@/utils/index.js'
import url from '@/config/url1.js'
export default {
    name: 'costInformation',
    data() {
        return {
            rolePermission:localStorage.getItem('role'),
            condition: '',
            status: true,
            dialogFormVisible: false,//弹出框
            row: {},
            list: [],//表格数据
            currentPage: 1, // 当前页数
            pageSize: 10, // 每页显示的数据量
            total: 0, // 总数据量
            obj: {}, // 临时对象更新费用的参数
            feeName: '',//费用名称
            tax: '',//税
            rules: {
                feeName: [{ required: true, message: '请输入费用名称', trigger: 'blur' }],
                tax: [{ required: true, message: '请输入税率', trigger: 'blur' }],
                // phone: [{ required: true, message: '请输入电话', trigger: 'blur' }],
                // dingtalkId: [{ required: true, message: '请输入钉钉ID', trigger: 'blur' }],
                // pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
            },

        }
    },
    created() {
        this.getData(1);

        // this.lo();
    },
    methods: {
        cancel() {
            this.dialogFormVisible = false;
            this.tax = '';
            this.feeName = ''
        },
        rowStyle() {
            return "text-align:center";
        },
        search() {
            this.getData(1);

        },
        // 页数发生改变时
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getData(this.currentPage);
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.getData(this.currentPage)

        },
        getData(page) {
            // this.currentPage=page;
            let URL = `${url.fee}?feeName=${this.condition}`
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    // this.total = res.data.data.total;
                    this.list = res.data.data;
                    this.computedStatus();
                } else {
                    this.$message.error(res.data.message);

                }
            })
        },
        //计算状态
        computedStatus() {
            for (const key in this.list) {
                if (this.list[key].status === 1) {
                    this.list[key].status = true;
                } else if (this.list[key].status === 0) {
                    this.list[key].status = false;
                }
            }
            return this.list;
        },
        //修改数据获取数据
        amendRow(row) {
            this.feeName = row.feeName;
            this.tax = row.tax;
            this.dialogFormVisible = true;
            this.row = row;
        },
        //确认修改
        confirmChange() {
            if (this.feeName === '' || this.tax === '') {
                this.$message.error('请输入完整信息');
                return;
            
            } else {
                this.dialogFormVisible = false;
                if (this.row) {
                    let obj = {
                        id: this.row.id,
                        feeName: this.feeName,
                        tax: this.tax,
                    }

                    this.obj = obj;
                } else {
                    let obj = {
                        feeName: this.feeName,
                        tax: this.tax,
                    }
                    this.obj = obj;
                }
                this.handdleUpdate();
                // 清空
                this.row = {};
                this.feeName = '';
                this.tax = '';
            }

        },

        //增加/修改接口
        handdleUpdate() {
            let URL = `${url.changeFee}`;
            req.post(URL, this.obj).then(res => {
                if (res.data.code === 200) {
                    this.$message({
                        type: 'success',
                        message: res.data.data
                    });
                    this.getData(1);
                }
                else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    });
                }
            })
        },
        //增加
        update() {
            this.dialogFormVisible = true;
        },
        //删除
        deleteRow(row) {
            this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let URL = `${url.delete}/${row.id}`;
                req.delete(URL).then(res => {
                    if (res.data.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getData(1);
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message
                        });
                    }
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 开关状态
        changeStatus(row) {
            let URL = `${url.changeStatus}/${row.id}`;
            req.put(URL).then(res => {
                if (res.data.code === 200) {
                    this.$message({
                        type: 'success',
                        message: '变更成功!'
                    });
                    this.getData(1);
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    });
                }
            })
        },
    },
}
</script>

<style lang="css" scoped>
::v-deep .el-form-item {
    margin-bottom: 10px;
}
</style>